import { z } from 'zod'

export const createOrgPayload = z.object({
  name: z.string(),
  roles: z.array(z.string()),
  settings: z.record(z.unknown()).optional(),
  metadata: z.record(z.unknown()).optional(),
})

export type CreateOrgPayload = z.infer<typeof createOrgPayload>

// (name, display name)
export const orgNamesSchema = z.tuple([z.string(), z.nullable(z.string())])

export type OrgNames = z.infer<typeof orgNamesSchema>

export type OrgNamesAndId = [string, string | null, string]

export const baseOrgSchema = z.object({
  org_id: z.string(),
  org_name: z.string(),
  org_display_name: z.string().nullish(),
  user_has_access: z.boolean(),
  org_slug: z.string().nullish(),
})

export const orgByParentSchema = baseOrgSchema.extend({
  children: z.array(baseOrgSchema),
})

export const orgsByParentResponseSchema = z.object({
  result: z.array(orgByParentSchema),
})

export type ChildOrg = z.infer<typeof baseOrgSchema>
export type OrgByParent = z.infer<typeof orgByParentSchema>
